<div class="action">
  <div class="user" *ngIf="gameUser">
    {{ gameUser.gameUserNumber }}
    <ng-container *ngIf="!gameUser.tournamentTeamUser.id">
      {{ gameUser.teamUser.user.lastName }} {{ gameUser.teamUser.user.firstName.substr(0,1) }}.
    </ng-container>
    <ng-container *ngIf="gameUser.tournamentTeamUser.id">
      {{ gameUser.tournamentTeamUser.leaguePlayer.lastName }} {{ gameUser.tournamentTeamUser.leaguePlayer.firstName.substr(0,1) }}.
    </ng-container>
  </div>
  <div class="user" *ngIf="!gameUser && gameLog.logType !== gameLogTypes.timeout">Тренер/Скамейка</div>
  <div class="type">
    {{ gameLog.logType  | localization: gameLogTypeLocalization }}
    <div class="small" *ngIf="gameLog.isPenaltyType() && gameLog.penaltyType">{{ gameLog.penaltyType.title }}</div>
  </div>
</div>
<div class="center">
  <div class="score" *ngIf="gameLog.isScoreType()">{{ gameLog.teamScore }}:{{ gameLog.competitorTeamScore }}</div>
  <mtg-chips [color]="gameLog.isScoreType()  || gameLog.logType === gameLogTypes.assist ? 'primary' : gameLog.isPenaltyType() ? 'bordered' : 'secondary'" class="datetime">
    <ng-container *ngIf="gameLog.time !== null">
      {{ gameLog.timeFormatted }}
    </ng-container>
    <ng-container *ngIf="gameLog.time === null">
      {{ gameLog.datetime | date: 'HH:mm' }}
    </ng-container>
  </mtg-chips>
</div>
<div class="action"></div>
